import { createDeliveryChargeTemplateValidation } from '../../utils/validationSchema';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { useForm } from 'react-hook-form';
import DeliveryChargeTemplateForm from './DeliveryChargeTemplateForm';
import Form from '../../layouts/Form';

const EditDeliveryChargeTemplate = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
  } = useForm<any>({
    resolver: yupResolver(createDeliveryChargeTemplateValidation),
    defaultValues: async () => {
      let data: any = await props?.refetch()
      return {
        ...data?.data
      }
    }
  });
  const { handleEdit, isLoading } = props;

  return (
    <Form
      handleSubmit={handleSubmit}
      handleFormSubmit={handleEdit}
      setError={setError}
      buttonLabel={"Update"}
      isLoading={isLoading}
    >
      <DeliveryChargeTemplateForm
        errors={errors}
        register={register}
        setValue={setValue}
        getValues={getValues}
      />
    </Form>
  );
}

export default EditDeliveryChargeTemplate
